<script setup>
import { CdrFormGroup, CdrCheckbox } from '@rei/cedar';
import { useReservationsStore } from '../../stores/day-cancellation/reservations';
import { isReservationDisabled, getReservationLabel } from './utils';

const reservations = useReservationsStore();
</script>

<template>
  <CdrFormGroup>
    <CdrCheckbox
      v-for="(reservation, idx) in reservations.items"
      :key="idx"
      v-model="reservations.selected"
      :disabled="isReservationDisabled(reservation)"
      :custom-value="reservation"
      :data-ui="`reservation-selector-checkbox-${idx}`"
      size="medium"
    >
      <span :data-ui="`reservation-selector-value-${idx}`">
        {{ getReservationLabel(reservation) }}
      </span>
    </CdrCheckbox>
  </CdrFormGroup>
</template>
